import { Outlet } from "react-router";

import { Stack } from "@mui/material";

import { UserPermission } from "@/common/contexts/current-user-context/CurrentUserContextProvider.types";
import withAuthorization from "@/common/hocs/with-authorization/withAuthorization";

function TemplatesTabInner() {
  return (
    <Stack flex={"1 1 100%"} overflow={"hidden"}>
      <Outlet />
    </Stack>
  );
}

export const TemplatesTab = withAuthorization(TemplatesTabInner, UserPermission.Supervisor);
